<script>
  import { 
    Row, Column, Block, Text, Icon, TextInput, DataTable, Popup, Image
  } from 'bastone'
  import { colors } from '../consts'
  import Page from '../components/page.svelte'
  import Header from '../components/header.svelte'
  import MyButton from '../components/button.svelte'
  import UploadBox from '../components/uploadbox.svelte'
  import Operate from '../components/datasetop.svelte'
  import Confirm from '../components/confirm.svelte'
  import { ChatBot, DataSet } from '../models'
  import { notify, screenWidth, bodyWidth, isDesktop, currentUser } from '../context'
  import { onMount } from 'svelte'
  import { meta } from 'tinro'

  const routeMeta = meta()
  let bot = {}
  let dataTable = null
  let searchText = ''
  let searching = false
  let loading = false
  let uploadShowing = false
  let confirm = null
  let showBulk = false
  let bulkData = ''
  let data = []

  $: columns = [
    {name: 'id', title: 'ID', width: '3rem', readonly: true},
    {name: 'content', title: '内容', width: '100%', editable: true},
    {name: 'operate', title: '操作', width: $isDesktop?'6rem':'4rem', component: Operate},
  ]

  async function addRow() {
    let ds = new DataSet({id: null, bot_id: bot.id, content:''})
    ds._editing = true
    data.unshift(ds)
    data = data
  }

  async function bulk() {
    if (bulkData.length <= 0) return
    await DataSet.bulk(bot.id, bulkData)
    showBulk = false
    DataSet.getList(botId).then(res=>{
      data = res || []
    })
  }

  async function search() {
    if (!searchText) {
      reset()
      return
    }
    searching = true
    data = await DataSet.search(bot.id, searchText)
  }

  async function reset() {
    if (!bot) return
    let res = await DataSet.getList(bot.id)
    if (!res) return
    data = res
    searching = false
    searchText = ''
  }

  async function loadMore() {
    loading = true
    let lastId = data[data.length-1].id
    let moreData = await DataSet.getList(bot.id, lastId)
    data = data.concat(moreData)
    loading = false
  }

  async function addFile(file, fileUrl) {
    let ok = await DataSet.addFile(bot.id, file.name, fileUrl)
    if (!ok) {
      notify('导入失败:' + file.name)
    } else {
      notify('上传成功,后台会排队导入,请稍后刷新查看')
      uploadShowing = false
    }
  }

  function empty() {
    confirm.show('清空后不可恢复，确定吗?', async ()=>{
      let ok = await DataSet.empty(bot.id)
      if (!ok) {
        notify('清空失败')
      } else {
        data = []
        bot.max_vector_id = 0
        notify('清空成功')
      }
    })
  }

  onMount(() => {
    let botId = routeMeta.params.botId
    bot = ChatBot.getOne(botId).then(res=>{
      bot = res
      if (!bot) {
        notify('无法获取Bot')
      }
    })
    
    DataSet.getList(botId).then(res=>{
      data = res || []
    })
    
    window.addEventListener('scroll', ()=>{
      if (!bot || searching ||　loading || data.length >= bot.vector_count) return
      let html = document.documentElement
      if (html.scrollTop + html.clientHeight >= html.scrollHeight-1) {
        loadMore()
      }
    })
  })
  
</script>


<Popup bind:showing={showBulk} clickDismiss={false}>
  <Block width=36rem padding=1.2rem backgroundColor=white lineHeight=1.6rem>
    <Row height=1.2rem xAlign=flex-start>
      <Text bold=1 size=1.2rem>批量录入</Text>
      <Block expand=1/>
      <Icon name=close size=1.4rem cursor=pointer on:click={()=>{showBulk=false}}/>
    </Row>
    <Block height=1.2rem/>
    <TextInput 
      multiline=1 width=100% height=20rem maxLength=32768 
      placeholder=每行一条数据，最大长度32K
      bind:value={bulkData}
    />
    <Block height=1rem/>
    <Row align=center width=100%>
      <MyButton 
        height=2rem width=5rem fill=1 fontSize=0.9rem icon=select iconSize=1.1rem space=0.3rem
        on:click={bulk}
      >提交</MyButton>
      <Block width=1rem/>
      <MyButton 
        height=2rem width=5rem fontSize=0.9rem icon=close iconSize=1.1rem space=0.3rem
        on:click={()=>{showBulk=false}}
      >取消</MyButton>
    </Row>

  </Block>



</Popup>

<Confirm bind:this={confirm}/>
<UploadBox bind:showing={uploadShowing} uploadDone={addFile}/>
<Page title='数据集管理'> 
  <Header buttonType='back'/>
  <Block minHeight=1.5rem/>
  <Column width={$bodyWidth}>
    <Row>
      <Image url={bot?.avatar_url} height=1.8rem/>
      <Block width=0.5rem/>
      <Text size=1.1rem bold=1>{bot.name || 'BOT'}</Text>
      <Block expand=1/>
      {#if $isDesktop}
      <Text>数据容量: {bot.vector_count || 0}/3000</Text>
      {#if $currentUser?.is_admin}
      <Block width=1.2rem/>
      <Text>消耗Token: {bot.used_tokens || 0}</Text>
      {/if}
      {/if}
    </Row>
    
    <Block height=1rem/>
    <Row width=100% wrap=1>
      <MyButton 
        height=2.2rem width=6.4rem fontSize=0.9rem icon=add iconSize=1.1rem border=1.5 space=0.3rem
        on:click={addRow}
      >添加数据</MyButton>

      <Block width=0.6rem/>
      <MyButton 
        height=2.2rem width=6.4rem fontSize=0.9rem icon=menu iconSize=1.1rem border=1.5 space=0.3rem
        on:click={()=>showBulk=true}
      >批量录入</MyButton>

      <Block width=0.6rem/>
      <MyButton 
        height=2.2rem width=6.4rem fontSize=0.9rem icon=upload iconSize=1.1rem border=1.5 space=0.3rem
        on:click={()=>{if(bot.status==1){notify('文件正在导入中，请稍后刷新重试');return}uploadShowing=true}}
      >上传文件</MyButton>

      <Block width=0.6rem/>
      <MyButton 
        height=2.2rem width=6.4rem fontSize=0.9rem icon=ashbin iconSize=1.1rem border=1.5 space=0.3rem
        on:click={empty}
      >清空数据</MyButton>
      
      <Block expand=1/>
      <TextInput 
          height=2.2rem width={$screenWidth>1024?'20rem':'10rem'} border=2 borderColor=gray
          placeholder=输入问题或关键词 fontSize=1rem bind:value={searchText}
      ></TextInput>
      <Block width=0.6rem/>
      <MyButton 
        height=2.2rem width=6.4rem fill=1 fontSize=0.9rem icon=search iconSize=1.1rem space=0.3rem
        on:click={search}
      >语义检索</MyButton>
      {#if $screenWidth > 1024}
      <Block width=0.6rem/>
      <MyButton 
        height=2.2rem width=4.5rem fontSize=0.9rem icon=refresh iconSize=1.1rem border=1.5 space=0.3rem
        on:click={reset}
      >重置</MyButton>
      {/if}
    </Row>
    <Block height=1rem/>
    <DataTable 
      columns={columns}
      headerBgColor={colors.snow}
      hoverBgColor={colors.snow}
      rowEditable={true}
      wrap=1
      bind:rows={data}
      bind:this={dataTable}
    ></DataTable>
    <Block height=2rem/>

  </Column>
</Page>


